import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";

export default function SidebarBrand({ isVisible = false, onClose, onOpen }) {
  return (
    <div className="new-sidebar-brand">
      {!isVisible ? (
        <button
          type="button"
          className="new-sidebar-brand__icon"
          aria-label="Open navigation"
          onClick={onOpen}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      ) : null}
      <span className="new-sidebar-brand__text">Suyool Corporate</span>
      {isVisible ? (
        <button
          type="button"
          className="new-sidebar-brand__close"
          aria-label="Close navigation"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      ) : null}
    </div>
  );
}
